import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Alert, Button } from "components/bootstrap";
import { Icon, ConfirmDialog } from "components/common";
const StyledAlert = styled(Alert)`
  padding: ${({ theme }) => theme.spacings.lg};
  margin: ${({ theme }) => theme.spacings.md};
  margin-top: 0;
`;
const Banner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const LeftItems = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacings.md};
`;
const BoldText = styled.h1`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.variant.danger};
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.md};
  width: ${({ $width }) => $width || "auto"};
  align-items: ${({ $align }) => $align || "flex-start"};
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  ${({ $justify }) => $justify ? css`
          justify-content: ${$justify};
        ` : css`
          gap: ${({ theme }) => theme.spacings.md};
        `}
  width: ${({ $fullWidth }) => $fullWidth ? "100%" : "auto"};
`;
const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.variant.danger};
`;
const LEFT_COLUMN_ITEM_LIST = [
  "Anomaly Detection AI",
  "Cloud Option",
  "Archiving",
  "Audit Logs for Graylog Cloud",
  "Dynamic Lookup Tables",
  "Advanced Alerting With Scripting",
  "Compliance Reporting",
  "Correlation & Aggregation Events",
  "Threat Intel Integrations"
];
const RIGHT_COLUMN_ITEM_LIST = [
  "Incident Investigation Workspaces",
  "Pre-build Security Parser & Dashboards",
  "Sigma Rules",
  "Parameterized Dashboarding",
  "Input & Output Integrations",
  "Threat Management",
  "Search Workflow, Templates & Filters",
  "Integrated Search & Alerting",
  "SOAR Integrations"
];
const TeaserPageLayout = ({ children }) => {
  const [showModal, setShowModal] = useState(true);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", noIcon: true }, /* @__PURE__ */ React.createElement(Banner, null, /* @__PURE__ */ React.createElement(LeftItems, null, /* @__PURE__ */ React.createElement(BoldText, null, "Security Demo"), /* @__PURE__ */ React.createElement("span", null, "For more information and booking a full demo of the product visit Graylog website.")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", role: "link", target: "_blank", href: "https://graylog.org/explore-security/" }, "Graylog Security ", /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new" })))), children, showModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: "Security Demo",
      onConfirm: () => setShowModal(false),
      onCancel: () => setShowModal(false),
      btnConfirmText: "Close"
    },
    /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("h2", { className: "text-danger" }, "OVERVIEW"), /* @__PURE__ */ React.createElement("p", null, "Graylog Security is designed to revolutionize cybersecurity for IT teams, offering the combined capabilities of SIEM, Security Analytics, Incident Investigation, and Anomaly Detection. By using our platform, you can work more efficiently, tackling critical tasks quicker, and mitigating risk caused by malicious actors and credential-based attacks."), /* @__PURE__ */ React.createElement(Row, { $justify: "space-between", $fullWidth: true }, /* @__PURE__ */ React.createElement(Col, null, LEFT_COLUMN_ITEM_LIST.map((item) => /* @__PURE__ */ React.createElement(Row, { key: item }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "check" }), /* @__PURE__ */ React.createElement("span", null, item)))), /* @__PURE__ */ React.createElement(Col, null, RIGHT_COLUMN_ITEM_LIST.map((item) => /* @__PURE__ */ React.createElement(Row, { key: item }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "check" }), /* @__PURE__ */ React.createElement("span", null, item))))))
  ));
};
export default TeaserPageLayout;
